/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyDetailResponse } from '../../models/company-detail-response';

export interface GetCompanyDetail$Params {
  id: number;
}

export function getCompanyDetail(http: HttpClient, rootUrl: string, params: GetCompanyDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompanyDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyDetailResponse>;
    })
  );
}

getCompanyDetail.PATH = '/api/company/{id}';
